export default __webpack_public_path__ + "static/media/demo-2.ec8ff2a0.png";